import React, { useState } from 'react';

import db from './firebase.config.js';
import firebase from 'firebase/app';
import "firebase/firestore";

import spotify_logo from './spotify.svg'
import ExpandMore from '@mui/icons-material/ExpandMore';
import LinkOutlined from '@mui/icons-material/LinkOutlined';

let nextArtistLinksId = 0;

export function artistLinks(meta) {
    if (!meta || typeof meta !== 'object' || Array.isArray(meta)) return [];
    return Object.entries(meta).flatMap(([key, value]) => {
        if (typeof value !== 'string' || !key.trim()) return [];
        try {
            const url = new URL(value.trim());
            if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return [];
            const names = { instagram: 'Instagram', linktree: 'Linktree', support: 'Support', facebook: 'Facebook', custom: 'Website', tiktok: 'TikTok', youtube: 'YouTube', website: 'Website', tickets: 'Tickets' };
            const label = Object.prototype.hasOwnProperty.call(names, key.toLowerCase()) ? names[key.toLowerCase()] : key.replace(/[_-]+/g, ' ').replace(/^./, first => first.toUpperCase());
            return [{ key, url: url.href, label }];
        } catch { return []; }
    });
}

const SOCIAL_ICONS = {
    instagram: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
        </svg>
    ),
    linktree: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3.172 3.464l5.656 5.657-1.414 1.414-5.657-5.657 1.415-1.414zm0 17.072l5.656-5.657-1.414-1.414-5.657 5.657 1.415 1.414zM20.828 3.464l-5.656 5.657 1.414 1.414 5.657-5.657-1.415-1.414zm0 17.072l-5.656-5.657 1.414-1.414 5.657 5.657-1.415 1.414zM11 2h2v20h-2z"/>
        </svg>
    ),
    support: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
    ),
};

function Track(props) {
    const artist = props.artist;
    const song = props.song_name;
    const track_id = props.track_id;
    const url = props.url;
    const cover_art = props.cover_art;
    const driver = props.driver;
    const passenger_id = props.passenger;
    const genres = props.genres;
    const meta = props.meta;
    const pax_session_id = props.session_id;

    const [expanded, setExpanded] = useState(false);
    const [linksId] = useState(() => `artist-links-${++nextArtistLinksId}`);
    const links = artistLinks(meta);
    // Old session rows lack bot; retain their non-personalized genre check.
    const isStrive = props.bot === false || (props.bot == null && Array.isArray(genres) && !genres.some(genre => ['perso', 'pax_perso'].includes(genre)));
    const hasMeta = isStrive && links.length > 0;

    async function spotifyClicked(e) {
        if(e) e.stopPropagation();
        if (!passenger_id || !track_id) return;
        try {
            const pax_doc = db.collection('Passengers').doc(passenger_id)
            await Promise.all([pax_doc.set({
                'tracksClicked' : firebase.firestore.FieldValue.arrayUnion(track_id)
            }, {merge: true}), db.collection('Artist_Analytics').doc(track_id).collection('passenger_id').doc(passenger_id).set({
            artist_name: artist || '',
            song_name: song || '',
            track_id: track_id,
            spotify_clicks: firebase.firestore.FieldValue.increment(1),
            driver: driver || '',
            passenger_id: passenger_id,
            time_clicked: firebase.firestore.FieldValue.serverTimestamp(),
        }, {merge: true})]);
        } catch {
            console.log('failed adding Spotify interaction');
        }
    }

    async function pax_clicked_socials(social_clicked) {
        if(!pax_session_id || !passenger_id) return;
        try {
            const passenger = db.collection('Passengers').doc(passenger_id);
            const session = passenger.collection('sessions').doc(pax_session_id);
            if ((await session.get()).exists) {
                    const unix_rn = Date.now() / 1000
                    const clicked_str = social_clicked + "_clicked"
                    await Promise.all([passenger.update({
                        'last_used' : firebase.firestore.FieldValue.serverTimestamp(),
                    }), session.update({
                        'actions': firebase.firestore.FieldValue.arrayUnion(clicked_str),
                        'interactions': firebase.firestore.FieldValue.arrayUnion({
                            'action' : 'socials_clicked',
                            'meta' : {'social_type' : social_clicked},
                            'time' : unix_rn,
                        }),
                    })]);
            }
        } catch (e) {
            console.log("failed adding socials interaction")
        }
    }

    const details = <span className="dark-track-info">
        <span className="track-title-line"><span className="dark-track-title">{song}</span></span>
        <span className="dark-track-artist">{artist}</span>
        <span className="track-subline">{props.queuedBy ? <span className={`queued-by ${props.queuedBy === 'You' ? 'queued-by-you' : ''}`}>Added by {props.queuedBy}</span> : Array.isArray(genres) && genres[0] !== 'perso' && genres[0] !== 'none' && <span className="track-genre">{genres.slice(0, 2).join(' · ')}</span>}{hasMeta && <span className="artist-links-cue">Artist links</span>}</span>
    </span>;

    return <div className={`track-item${hasMeta ? ' track-item-featured' : ''}`}>
        <div className="dark-track-row">
            <a className="track-art-link" href={url} target="_blank" rel="noopener noreferrer" onClick={spotifyClicked} aria-label={`Open ${song} on Spotify`}><img className="track-cover" src={cover_art || spotify_logo} alt="" /><img className="track-spotify" src={spotify_logo} alt="" /></a>
            {hasMeta ? <button type="button" className="track-feature-toggle" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-controls={linksId} aria-label={`${expanded ? 'Hide' : 'Show'} artist links for ${artist}`}>{details}<ExpandMore className={expanded ? 'expanded-chevron' : ''} aria-hidden="true" /></button> : <>{details}<a className="track-open" href={url} target="_blank" rel="noopener noreferrer" onClick={spotifyClicked} aria-label={`Open ${song} on Spotify`}>↗</a></>}
        </div>
        {hasMeta && <div hidden={!expanded} id={linksId} role="region" aria-label={`${artist} links`} className="artist-links">{links.map(({ key, url: linkUrl, label }) => <a key={key} href={linkUrl} target="_blank" rel="noopener noreferrer" onClick={() => pax_clicked_socials(key)} aria-label={`${label} for ${artist}`}><span aria-hidden="true">{SOCIAL_ICONS[key.toLowerCase()] || <LinkOutlined />}</span>{label}<span className="artist-link-arrow" aria-hidden="true">↗</span></a>)}</div>}
    </div>;
}

export default Track;
